export const addItem = (array, value) => {
  return [...array, value];
};

export const removeItem = (array, index = 0) => {
  const updatedArray = [...array];
  updatedArray.splice(index, 1);
  return updatedArray;
};

export const replaceItem = (array, index = 0, value) => {
  const updatedArray = [...array];
  updatedArray.splice(index, 1, value);
  return updatedArray;
};

export const findValueInObjectsArray = (array, {keySearch, valueSearch}, keyToReturn) => {
  const element = array.find((item) => item[keySearch] === valueSearch);
  return element ? element[keyToReturn] : '';
};

export const filterObjectsArrayByValue = (array = [], key, value) => {
  return array.filter((item) => item[key] !== value);
};
